<template>
  <div class="card-header m-b-10">
    <form
      class="box-search"
      @reset.prevent="triggerFilter(false)"
      @submit.prevent="triggerFilter()"
    >
      <div class="form-group">
        <input
          type="text"
          v-model.trim="search.textSearch"
          class="form-control f12 hc-37"
          placeholder="Từ khóa"
        />
      </div>
      <div class="form-group">
        <Select2
          placeholder="Tỉnh thành"
          v-model="search.cityCode"
          :options="provinceList">
        </Select2>
      </div>
      <div class="form-group">
        <Select2
          placeholder="Trạng thái"
          v-model="search.merchantAgentStatus"
          :options="Config.merchantStatus">
        </Select2>
      </div>

      <div class="form-group">
        <DateRangePicker
          class="w-100"
          :ranges="false"
          v-model="search.createAt"
        >
          <template v-slot:input="picker">
            <label v-if="picker.startDate && picker.endDate" class="align-middle text-center">
              {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
            </label>
            <label
              v-else
              style="min-width: 13.5em"
              class="align-middle font-size-12 time-placeholder"
            >
              Thời gian tạo
            </label>
          </template>
        </DateRangePicker>
        <span
          v-show="search.createAt.startDate || search.createAt.endDate"
          class="position-absolute"
          style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer"
          @click="clearTime(search.createAt)"
        >
          ✕
        </span>
      </div>

      <div class="form-group">
        <DateRangePicker
          class="w-100"
          :ranges="false"
          v-model="search.deliveryTime"
        >
          <template v-slot:input="picker">
            <label v-if="picker.startDate && picker.endDate" class="align-middle text-center">
              {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
            </label>
            <label
              v-else
              style="min-width: 13.5em"
              class="align-middle font-size-12 time-placeholder"
            >
              Thời gian giao hàng
            </label>
          </template>
        </DateRangePicker>
        <span
          v-show="search.deliveryTime.startDate || search.deliveryTime.endDate"
          class="position-absolute"
          style="right: 10px; top: 50%; transform: translateY(-50%); cursor: pointer"
          @click="clearTime(search.deliveryTime)"
        >
          ✕
        </span>
      </div>

      <div class="form-group">
        <Select2
          placeholder="Trạng thái giao hàng"
          v-model="search.shippingStatus"
          :options="getOptionShippingStatus">
        </Select2>
      </div>
      <div class="form-group">
        <Select2
          placeholder="Hình thức vận chuyển"
          v-model="search.handoverType"
          :options="getOptionsHandoverType">
        </Select2>
      </div>
      <!-- Action Filter -->
      <div class="form-group form-group-action action-h">
        <button type="submit" class="pt-2 mr-2 btn btn-primary hc-37">
          <i class="bx bx-filter-alt"></i> Lọc
        </button>
        <button type="reset" class="pt-2 mr-2 btn btn-outline-light hc-37">
          <i class="bx bx-filter-alt"></i> Bỏ lọc
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import moment from 'moment'
import Config from '@/thirdParty/config'
import cloneDeep from 'lodash/cloneDeep'

const searchDefault = {
  textSearch: '',
  cityCode: '',
  merchantAgentStatus: '',
  createAt: {
    startDate: null,
    endDate: null
  },
  deliveryTime: {
    startDate: null,
    endDate: null
  },
  shippingStatus: '',
  handoverType: ''
}
export default {
  name: 'FilterMerchantForm',
  data () {
    return {
      search: { ...cloneDeep(searchDefault) },
      provinceList: [],
      Config
    }
  },
  computed: {
    getOptionShippingStatus () {
      return this.Config.getSearch(this.Config.optionsShippingStatus)
    },
    getOptionsHandoverType () {
      return this.Config.getSearch(this.Config.optionsHandoverType)
    }
  },
  async created () {
    this.provinceList = await this.getProvinceMx()
  },
  methods: {
    triggerFilter (isFilter = true) {
      if (!isFilter) {
        this.search = { ...cloneDeep(searchDefault) }
      }
      const params = this.params()
      this.$emit('change', params)
    },
    clearTime (value) {
      value.startDate = null
      value.endDate = null
    },
    formatDateTimeParams (date) {
      return moment(date).valueOf()
    },
    params () {
      const body = {}
      if (this.search.textSearch.trim()) body.textSearch = this.search.textSearch.trim()
      if (this.search.cityCode) body.cityCode = this.search.cityCode
      if (this.search.merchantAgentStatus && this.search.merchantAgentStatus !== '0') {
        body.merchantAgentStatus = this.search.merchantAgentStatus
      }
      if (this.search.createAt.startDate || this.search.createAt.endDate) {
        body.startDate = moment(this.search.createAt.startDate).startOf('day').valueOf()
        body.endDate = moment(this.search.createAt.endDate).endOf('day').valueOf()
      }
      if (this.search.deliveryTime.startDate || this.search.deliveryTime.endDate) {
        body.deliveryStartDate = moment(this.search.deliveryTime.startDate).startOf('day').valueOf()
        body.deliveryEndDate = moment(this.search.deliveryTime.endDate).endOf('day').valueOf()
      }

      if (this.search.shippingStatus && this.search.shippingStatus !== '0') {
        body.shippingStatus = this.search.shippingStatus
      }
      if (this.search.handoverType && this.search.handoverType !== '0') {
        body.handoverType = this.search.handoverType
      }
      return body
    }
  }
}
</script>
<style scoped>
  .action-h {
    height: 41px;
  }
</style>
